export default {
  MazegameTitle: '迷宮遊戲設定',
  topic: '遊戲主題',
  inputTopic: '請輸入遊戲主題',
  questionSettings: '題目設定',
  questionNumber: '題目',
  options: '選項',
  addOption: '新增選項',
  addQuestion: '新增題目',
  removeQuestion: '移除題目',
  removeOption: '移除選項',
  questionText: '題目',
  inputQuestionText: '請輸入題目文字',
  optionSettings: '選項設定 (2-4個選項)',
  optionContent: '選項內容',
  setCorrectAnswer: '設為正確答案',
  clearData: '清空資料',
  saveSettings: '儲存設定',
  maxQuestions: '最多只能新增10個題目',
  maxOptions: '最多只能新增4個選項',
  minOptions: '至少需要2個選項',
  questionExists: '該題目已存在',
  settingsSaved: '設定已儲存',
  pleaseCompleteSettings: '請完成所有必填項目',

  // 遊戲畫面
  pauseButton: '暫停',
  resumeButton: '繼續',
  exitButton: '離開',
  restartButton: '重新開始',
  progress: '進度',
  question: '題目',
  totalQuestions: '總題數',
  gamePaused: '活動暫停',

  // 反饋訊息
  correctAnswerMsg: '答對了！',
  wrongAnswer: '答案不正確，請再試試！',
  gameCompleted: '恭喜完成所有題目！',
  gameOver: '遊戲結束',

  // 結算畫面
  finalScore: '最終得分',
  accuracy: '正確率',
  timeSpent: '用時',
  wrongAttempts: '錯誤次數',

  // 控制說明
  controlHint: '使用方向鍵移動',
  findCorrectExit: '找到正確答案的出口',

  // 答案參考
  referenceAnswers: '參考答案',
  sendSuccess: '遊戲資料已成功推送！',
  sendCooldown: '已按過送出，請等候1分鐘才可再操作',

  // 新版 Push 功能
  pushSuccess: '遊戲活動已成功推送！',
  pushFailed: '推送失敗：{message}',
  tokenRefreshing: '正在刷新授權資訊，請稍後再試...',

  // 小螢幕警告
  smallScreenWarning: '本遊戲為桌面版介面，建議於電腦平板使用，且最低螢幕寬度需求為 1200px*800px',
  currentRank: '目前排名',
  totalParticipants: '總參與人次',
};
